import { useState, useEffect, useCallback, useRef } from "react"
import styles from "./styles.module.scss"
import type { FC, HTMLAttributes } from "react"

interface BackgroundProps
extends HTMLAttributes<SVGSVGElement> {}

const initialScreenSize = { width: 0, height: 0 }


export const Background: FC<BackgroundProps> = props => {
  const [screenSize, setScreenSize] = useState(initialScreenSize)
  const shadowRef = useRef<SVGCircleElement>(null)
  const lightRef = useRef<SVGCircleElement>(null)
  const checkCirclePosition = useCallback(({ clientX, clientY }: MouseEvent) => {
    const x = screenSize.width - clientX
    const y = screenSize.width - clientY
    shadowRef.current.style.transform = `translate(${x}px, ${y}px)`
    lightRef.current.style.transform = `translate(${clientX}px, ${clientY}px)`
  }, [screenSize])

  useEffect(() => {
    const checkSize = () => setScreenSize({
      height: window.innerHeight,
      width: window.innerWidth,
    })
    checkSize()
    window.addEventListener('resize', checkSize, { passive: true })
    return () => window.removeEventListener('resize', checkSize)
  }, [setScreenSize])

  useEffect(() => {
    window.addEventListener('mousemove', checkCirclePosition)
    return () => window.removeEventListener('mousemove', checkCirclePosition)
  })

  return (
    <svg {...props} className={styles.background} {...screenSize}>
      <defs>
        <radialGradient id="shadowGradient">
          <stop offset="10%" stopOpacity="1" stopColor="var(--color-navy-dark)" />
          <stop offset="95%" stopOpacity="0" stopColor="var(--color-navy-regular)" />
        </radialGradient>
        <radialGradient id="lightGradient">
          <stop offset="10%" stopOpacity="1" stopColor="var(--color-navy-light)" />
          <stop offset="95%" stopOpacity="0" stopColor="var(--color-navy-regular)" />
        </radialGradient>
      </defs>
      <circle fill="url('#shadowGradient')" ref={shadowRef}
        r={Math.max(screenSize.width, screenSize.height) * .7}
        cx={0} 
        cy={0} />
      <circle fill="url('#lightGradient')" ref={lightRef}
        r={Math.max(screenSize.width, screenSize.height) * .5}
        cx={0}
        cy={0} />
    </svg>
  )
}
